import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MediaLibraryHttpService } from '../http/media-library-http.service';

@Injectable({
    providedIn: 'root',
})
export class MediaLibraryHttpResolverService implements Resolve<any> {
    constructor(private mediaLibraryHttpService: MediaLibraryHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.mediaLibraryHttpService.getAllFolders();
    }
}
